import { DomainType } from "@/Shared";

export const SORT_DESCENDING_DOMAINS: DomainType[] = [
    'Lease',
    'Transaction',
    'Activity',
    'Planning',
    'Document',
    'BirthWish'
];

export const useSortDomain = <T,>(domainType: DomainType) => {

    const sortData = (data: T[]): T[] => {
        if (data.length <= 1) return data;

        return [...data].sort((a, b) => {
            if ('function' === typeof (a as any).compareTo) {

                if (SORT_DESCENDING_DOMAINS.includes(domainType)) {
                    return (b as any).compareTo(a);
                }
                return (a as any).compareTo(b);
            }
            return 0;
        });
    };

    return sortData;
};